import { __awaiter } from "tslib";
import Vue from 'vue';
import { classToPositiveNumber } from './mixins/classToPositiveNumber';
import { mapGetters } from 'vuex';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import coinInfo from './components/coin-info/coinInfo.vue';
import coinCard from './components/coin-card/coinCard.vue';
import draggable from 'vuedraggable';
import services from '@/services';
import finRes from './components/fin-res/finRes.vue';
import { BigNumber } from 'bignumber.js';
import _ from 'lodash';
const debouncedCoinOrderUpdate = _.debounce(function (settings) {
    services.v2.widgets.changeFuturesSettings(settings);
}, 3000);
export default Vue.extend({
    name: 'currencyWallet',
    props: {
        opened: {
            type: Boolean,
            default: false
        },
        isItOnTop: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        closeOnClick: true,
        wssMultiAssets: null,
        dragging: false,
        additionalAssetPanelOpen: false,
        additionalAssets: [],
        showMenu: false,
        settings: {
            multiAssets: false
        },
        menuLoaders: {
            multiAssets: false
        },
        finResetLoadingTotal: false,
        finResetLoadingUSDT: false,
        finResetLoadingUSDC: false,
        finResetLoadingBTC: false,
        selectedSecondaryAsset: 'USDC'
    }),
    watch: {
        getFuturesSettings() {
            this.updateSettings(this.getFuturesSettings);
        },
        getPopupIsOpened(v) {
            if (!v) {
                this.closeOnClick = true;
                this.updateSettings(this.getFuturesSettings);
            }
        },
        getFuturesAdditionalCoins() {
            const isMaSet = this.getFuturesSettings.multiAssets;
            const deposit = Object.entries(this.storeState('futuresWidget').deposit).map(([name, value]) => {
                const val = value;
                if ((val.lt(0) || val.gt(0)) && name !== 'TOTAL') {
                    return {
                        name: name.toUpperCase(),
                        value
                    };
                }
            }).filter((el) => el);
            this.additionalAssets = isMaSet ? deposit : this.getFuturesAdditionalCoins;
        }
    },
    computed: Object.assign(Object.assign(Object.assign(Object.assign({}, mapGetters('popupModule', ['getPopupIsOpened'])), mapGetters('user', ['getUserData'])), mapGetters('mainPageModules', {
        getUSDRates: 'getUSDRates',
        getFixedUSDRates: 'getFixedUSDRates',
        storeState: 'getMainPageWidget',
        getFuturesSettings: 'getFuturesSettings',
        getFuturesAdditionalCoins: 'getFuturesAdditionalCoins',
        getFuturesFinres: 'getFuturesFinres',
        getPositionsTable: 'getPositionsTable',
        getFuturesAvailableSecondaryCoins: 'getFuturesAvailableSecondaryCoins',
        getLimitsBidsTable: 'getLimitsBidsTable',
        getFuturesCoinsConvertedToUSD: 'getFuturesCoinsConvertedToUSD'
    })), { ratioSecondaryAsset() {
            const available = BigNumber(this.storeState('futuresWidget').available[this.selectedSecondaryAsset.toLowerCase()]);
            const deposit = BigNumber(this.storeState('futuresWidget').deposit[this.selectedSecondaryAsset.toLowerCase()]);
            return this.getRatio(available, deposit);
        },
        secondaryFinResultLoaderString() {
            return `finResetLoading${this.selectedSecondaryAsset}`;
        },
        secondaryFinResultLoader() {
            return this[`finResetLoading${this.selectedSecondaryAsset}`];
        }, optionList() {
            return this.getFuturesAvailableSecondaryCoins.map((asset) => { return { key: asset, value: asset }; });
        },
        showMultiAssetsCog() {
            return this.getFuturesSettings.multiAssets && this.showAdditionalControls;
        },
        isMenuLoading() {
            return Object.values(this.menuLoaders).some(key => key);
        }, showAdditionalControls() {
            return !this.storeState('futuresWidget').loadError && !this.storeState('futuresWidget').isRetry;
        }, usdTotalActiveBalance() {
            const positions = Object.assign([], this.getPositionsTable.items);
            const limits = Object.assign([], this.getLimitsBidsTable.items);
            const leveragesData = JSON.parse(localStorage.getItem('leverages') || '');
            const getLeverageVal = (ticker) => leveragesData[ticker];
            const tickers = {};
            const allOrders = [...positions, ...limits];
            allOrders.forEach((order) => {
                tickers[order.ticker] = {
                    short: [],
                    long: []
                };
            });
            positions.forEach((currentPosition) => {
                const leverageVal = leveragesData[currentPosition.ticker];
                const positionValue = currentPosition.volume.multipliedBy(currentPosition.positionPrice).div(leverageVal);
                const direction = currentPosition.direction === 'Шорт' ? 'short' : 'long';
                tickers[currentPosition.ticker][direction].push(positionValue);
            });
            limits.forEach((currentBid) => {
                const leverageVal = getLeverageVal(currentBid.ticker);
                const bidValue = currentBid.volume.multipliedBy(currentBid.positionPrice).div(leverageVal);
                const direction = currentBid.direction === 'Шорт' ? 'short' : 'long';
                const ticker = currentBid.ticker;
                tickers[ticker][direction].push(bidValue);
            });
            const negative = Object.keys(tickers).reduce((acc, current) => {
                const shorts = tickers[current].short;
                const longs = tickers[current].long;
                const short = shorts.reduce((total, number) => total.plus(number), BigNumber(0));
                const long = longs.reduce((total, number) => total.plus(number), BigNumber(0));
                let result = 0;
                result = short.gt(long) ? short : long;
                acc = acc.plus(result);
                return acc;
            }, BigNumber(0));
            const positionDelta = positions.reduce((acc, position) => {
                const usdtPositionValue = position.result;
                acc = acc.plus(usdtPositionValue);
                return acc;
            }, BigNumber(0));
            const positionDeltaUsd = positionDelta.multipliedBy(this.getUSDRates.USDT);
            const usdtNegativeTotal = negative.abs().multipliedBy(this.getUSDRates.USDT);
            let result = this.usdTotalDepositBalance.minus(usdtNegativeTotal).plus(positionDeltaUsd);
            if (result.isNaN())
                result = this.usdTotalDepositBalance;
            return result.lt(BigNumber(0)) ? BigNumber(0) : result;
        },
        usdTotalDepositBalance() {
            let result = BigNumber(0);
            this.additionalAssets.forEach((coin) => {
                if (coin.value.isZero() || !this.getUSDRates[coin.name])
                    return;
                result = result.plus(coin.value.multipliedBy(this.getUSDRates[coin.name]));
            });
            this.$store.commit('mainPageModules/setTotalFuturesDepositUSD', BigNumber(result));
            return result;
        },
        getOrderSettingsValue() {
            const defaultOrder = ['BTC', 'ETH', 'BNB', 'XRP', 'USDC', 'FDUSD', 'TUSD'];
            const currentOrderCoins = this.additionalAssets.map((asset) => asset.name);
            const orderSpotCoins = Array.from(new Set([...currentOrderCoins, ...defaultOrder]));
            return orderSpotCoins;
        } }),
    created() {
        this.$store.dispatch('mainPageModules/loadFuturesData', true);
    },
    mixins: [classToPositiveNumber],
    methods: {
        getFinresValueByCoinName(coinName) {
            const isCoinInUSD = this.isCoinConvertedToUSD(coinName);
            const valueMultiplier = isCoinInUSD ? this.getFixedUSDRates[coinName] : 1;
            const initValue = this.getFuturesFinres[coinName.toLowerCase()].value;
            return initValue.multipliedBy(valueMultiplier);
        },
        isCoinConvertedToUSD(coin) {
            return this.getFuturesCoinsConvertedToUSD.includes(coin);
        },
        changeCoinFinresUSDStatus(coin) {
            const updatedConvertedUSDSettings = new Set(this.getFuturesCoinsConvertedToUSD);
            const action = updatedConvertedUSDSettings.has(coin) ? 'delete' : 'add';
            updatedConvertedUSDSettings[action](coin);
            this.$store.commit('mainPageModules/setFuturesCoinsConvertedToUSD', Array.from(updatedConvertedUSDSettings));
            debouncedCoinOrderUpdate({ sortedCoins: [...this.getOrderSettingsValue, 'USDT'], convertedCoins: this.getFuturesCoinsConvertedToUSD });
        },
        dragEndHandler() {
            this.dragging = false;
            debouncedCoinOrderUpdate({ sortedCoins: [...this.getOrderSettingsValue, 'USDT'], convertedCoins: this.getFuturesCoinsConvertedToUSD });
        },
        updateSelectedAsset(value) {
            this.selectedSecondaryAsset = value;
        },
        getRatio(available, deposit) {
            if (!deposit)
                return 100;
            if (!available)
                return 0;
            if (available.div(deposit).isNaN())
                return 100;
            return Number(available.div(deposit).multipliedBy(100));
        },
        enableMultiAssets() {
            this.wssMultiAssets = new WebSocket(`wss://${window.location.host}/ws/enable-multiassets/`);
            this.wssMultiAssets.onmessage = (message) => __awaiter(this, void 0, void 0, function* () {
                const { event, data } = JSON.parse(message.data);
                if (event !== 'completed')
                    return;
                yield this.resetFinres(['USDT', 'BTC', 'ETH', 'BNB', 'XRP', 'USDC', 'FDUSD', 'TUSD', 'USD'], 'finResetLoadingTotal', true);
                this.$store.commit('popupModule/setSlotData', { isLoading: false });
                setTimeout(() => { this.$store.commit('popupModule/setClosed'); }, 200);
                this.showMenu = false;
                const isSuccess = data.status === 'success';
                const content = isSuccess ? this.$t('mainPage.alerts.content.tradeModeChanged') : data.message;
                const type = isSuccess ? 'success' : 'error';
                this.$store.dispatch('alertsBus/openAlert', {
                    title: this.$t(`popups.titles.${type}`),
                    type,
                    autoDelete: true,
                    content
                });
            });
        },
        disableMultiAssets() {
            return __awaiter(this, void 0, void 0, function* () {
                this.menuLoaders.multiAssets = true;
                const response = yield this.services.v2.trade.removeMA();
                this.menuLoaders.multiAssets = false;
                const content = response.success ? this.$t('mainPage.alerts.content.tradeModeChanged') : response.data.errors.join('/n');
                const vm = this;
                const type = response.status === 200 ? 'success' : 'error';
                this.showMenu = false;
                yield vm.$store.dispatch('mainPageModules/loadFuturesData');
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t(`popups.titles.${type}`),
                    type,
                    autoDelete: true,
                    content
                });
            });
        },
        multiAssetModeChangeHandler() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                this.closeOnClick = false;
                if (this.getFuturesSettings.multiAssets)
                    return this.disableMultiAssets();
                this.menuLoaders.multiAssets = true;
                const response = yield this.services.mainService.hasIsolated();
                this.menuLoaders.multiAssets = false;
                if (!response.success) {
                    this.showMenu = false;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('popups.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: this.$t('mainPage.alerts.content.failedToChangeTradeMode')
                    });
                    this.settings.multiAssets = this.getFuturesSettings.multiAssets;
                    return;
                }
                const { hasIsolated } = response.data;
                this.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: this.$t('mainPage.popups.titles.enableMa'),
                    slot: {
                        name: 'enableMultiAssetModeConfirmPopupChunk',
                        data: {
                            tickersWillSetToCross: hasIsolated
                        },
                        on: {
                            onContinue() {
                                vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                                vm.enableMultiAssets();
                            },
                            onClose() {
                                vm.settings.multiAssets = false;
                                vm.$store.commit('popupModule/setClosed');
                                vm.showMenu = false;
                            }
                        }
                    }
                });
            });
        },
        updateSettings(settings) {
            this.settings.multiAssets = settings.multiAssets;
        },
        multiAssetInfoClickHandler() {
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('mainPage.popups.titles.maMode'),
                slot: {
                    name: 'multiAssetsInfoPopupChunk'
                }
            });
        },
        resetFinres(values, loader, all = false) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm[loader] = true;
                const response = yield vm.services.v2.widgets.resetFuturesFinres({ coins: values });
                vm[loader] = false;
                if (!response.success) {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('mainPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        onlyContent: true,
                        content: all ? vm.$t('mainPage.alerts.content.totalFinrezNotReset', { wallet: 'фьючерсного' }) : vm.$t('mainPage.alerts.content.finrezNotReset', { value: values })
                    });
                    return;
                }
                yield vm.$store.dispatch('mainPageModules/loadFuturesData');
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('mainPage.alerts.titles.success'),
                    type: 'success',
                    autoDelete: true,
                    onlyContent: true,
                    content: all ? vm.$t('mainPage.alerts.content.totalFinrezReset', { wallet: 'фьючерсного' }) : vm.$t('mainPage.alerts.content.finrezReset', { value: values })
                });
            });
        }
    },
    components: {
        coinCard,
        draggable,
        finRes,
        coinInfo
    }
});
